import $ from 'jquery';
import { colors } from '../colors';
import { doubleAxes, value, percentage } from '../options';

class RegistedCodes {
  constructor() {
  }

  static Chart(callback) {
    let ctx = $('#charts__registed-codes');
    let check = $('canvas').is('#charts__registed-codes');
    let project_id = $('[data-project-id]').data('project-id');
    let datasets = [];
    let labels;

    let first_week = parseUrl('start_week')
    let end_week = parseUrl('end_week')
    let days_from = parseUrl('days_from')
    let days_to = parseUrl('days_to')
    let period_filter_type = parseUrl('period_filter_type')
    let periodParams = '&period_filter_type=' + period_filter_type +
                       '&start_week=' + first_week + '&end_week=' + end_week +
                       '&days_from=' + days_from + '&days_to=' + days_to

    if(check) {
      $.ajax({
        url: '/api/v1/statistics/codes_by_periods?project_id=' + project_id + periodParams,
        method: 'GET',
        dataType: 'json',
        success: function (response) {
          initChart(response)
        }
      });

      let initChart = function(response){
        if (response.valid_codes_actual.length == 0){
          $(ctx).parent().html('<div class="not_enough_data"><b>Для отображения недостаточно данных</b></div>')

          if (typeof callback == "function") {
            callback('not_enough_data');
          }

          return;
        }

        let actual_dataset = {
          yAxisID: "bars",
          type: "line",
          label: "Количество валидных кодов (факт за период)",
          data: response.valid_codes_actual,
          backgroundColor: colors.yellow[300],
          hoverBackgroundColor: colors.yellow[500],
          borderColor: colors.yellow[500],
          hoverBorderColor: colors.yellow[500],
          fill: false,
          datalabels: value
        }

        datasets.push(actual_dataset);

        if (response.codes_plan){
          let plan_datasets = [
            {
              yAxisID: "bars",
              type: "line",
              label: "Количество валидных кодов (план за период)",
              data: response.codes_plan,
              backgroundColor: colors.green[300],
              hoverBackgroundColor: colors.green[500],
              borderColor: colors.green[500],
              hoverBorderColor: colors.green[500],
              fill: false,
              datalabels: value
            },
            {
              yAxisID: "lines",
              type: "scatter",
              label: "Процент от плана",
              data: response.plan_percentage,
              backgroundColor: colors.orange[300],
              hoverBackgroundColor: colors.orange[500],
              borderColor: colors.orange[500],
              hoverBorderColor: colors.orange[500],
              pointBackgroundColor: colors.orange[300],
              hoverPointBackgroundColor: colors.orange[500],
              pointBorderColor: colors.orange[500],
              hoverPointBorderColor: colors.orange[500],
              showLine: false,
              fill: false,
              datalabels: percentage
            }
          ]
          $.merge(datasets, plan_datasets)
        }

        let data = {
          labels: response.labels,
          datasets: datasets
        };

        var options = Object.assign({}, doubleAxes);
        options['scales']['yAxes'][1]['ticks']['max'] = 100;
        options['scales']['yAxes'][1]['ticks']['callback'] = function(value, index, values) {
          return String(value) + '%';
        };

        let animationOptions = {
          animation: {
            onComplete: function(){
              if (typeof callback == "function") {
                callback(newChart.toBase64Image());
              }
            }
          }
        }

        let newChart = new Chart(ctx, {
          type: "bar",
          data: {
            labels: data.labels,
            datasets: data.datasets
          },
          options: { ...options, ...animationOptions }
        });

        let showValue = true
        let newValueOptions = {}

        $('#registed-codes-switch').on('click', function(){
          $(this).toggleClass('on')

          if(showValue == true)
          {
            showValue = false
            newValueOptions = {}
          }
          else
          {
            showValue = true
            newValueOptions = value
          }

          data.datasets.forEach(function(dataset) {
            dataset['datalabels'] = newValueOptions
          })

          newChart.update()
        })
      }
    }
  }

  static onInit() {
    RegistedCodes.Chart();
  }
}

export default RegistedCodes;
